"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Condition = void 0;
const with_class_name_1 = require("../with-class-name");
class Condition extends with_class_name_1.WithClassName {
    constructor(name) {
        super();
        this.negate = false;
        this.depth = 0;
        this.name = name;
    }
    setDepth(value) {
        this.depth = value;
    }
}
exports.Condition = Condition;



//////////////////
// WEBPACK FOOTER
// ./~/rules-config/lib/casa-rules-v2/condition.js
// module id = 1222
// module chunks = 0